import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Row = styled.div<{ $gap?: string, $fullWidth?: boolean; }>(({ $gap, $fullWidth }) => css`
  display: flex;
  flex-direction: row;
  gap: ${$gap || '1rem'};
  align-items: flex-end;
  width: ${$fullWidth ? '100%' : 'auto'};
`);

export const FormGroup = styled.div`
  margin: 0;
  width: 100%;

  & .form-group {
    margin: 0;
  }
`;

export const EvidenceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;
  padding-right: 1rem;
  margin-bottom: 1rem;

  overflow-y: auto;
`;

export const EvidenceRow = styled(Row)`
  align-items: flex-end;

  & svg {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover svg {
    opacity: 1;
  }
`;

export const IconButton = styled.div<{ $danger?: boolean; }>(({ theme, $danger }) => css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  padding: 0 8px;

  color: ${$danger ? theme.colors.brand.primary : theme.colors.global.textDefault};
`);

export const StyledLink = styled.span(({ theme }) => css`
  font-size: .9rem;
  cursor: pointer;
  color: ${theme.colors.global.textDefault};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`);

export const StyledSectionWrapper = styled.div(({ theme }) => css`
  width: 100%;
  border: 1px solid ${theme.colors.variant.lighter.default};
  border-radius: 5px;
  padding: 10px;
  background-color: ${theme.colors.global.contentBackground};
`);

export const TH = styled.th(({ theme }) => css`
  vertical-align: middle !important;
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 16px 8px !important;
  border-bottom: 2px solid ${theme.colors.gray[80]} !important;
  background-color: ${theme.colors.table.head.background} !important;
`);

export const TD = styled.td<{ $main?: boolean; }>(({ theme, $main }) => css`
  vertical-align: middle !important;
  max-width: 300px;
  padding: 16px 8px !important;
  color: ${$main ? theme.colors.global.link : theme.colors.brand.tertiary};
  cursor: ${$main ? 'pointer' : 'normal'};
  font-weight: ${$main ? 'bold' : 'regular'};

  &:hover {
    color: ${$main ? theme.colors.global.linkHover : theme.colors.brand.tertiary};
    text-decoration: ${$main ? 'underline' : 'none'};
  }

  &:not(:last-child) {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`);
